import { render, staticRenderFns } from "./PaymentSpkb.vue?vue&type=template&id=29eb2a6c&"
import script from "./PaymentSpkb.vue?vue&type=script&lang=js&"
export * from "./PaymentSpkb.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSpkb.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports